import api from '@/services';

export const getGamesForToday = async () => {
  const response = await api.Game.getGamesForToday();
  return response;
};
